export const addCurrentFiltersToUrl = (filters) => {
    const params = Object.entries(filters).map((filter) => filter[0] + '=' + filter[1])
    const paramsString = params.join('&')
    const url = window.location.pathname + (paramsString ? '?' + paramsString : '')
    history.pushState({}, document.title, url)
  }

  export const getFiltersFromUrl = () => {
    const params = new URLSearchParams(window.location.search)
    const filters = {}
    params.forEach((value, filter) => {
      filters[filter] = value
    })
    return filters
  }
